import AuthStore from 'src/stores/AuthStore';

export const authStore = new AuthStore();
